import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconHwp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
			fill: "#34AEE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6821 7.94438C13.5596 7.89888 15.118 9.38568 15.1606 11.2634C15.2031 13.1411 13.714 14.697 11.8362 14.7369C9.96248 14.7765 8.4106 13.2912 8.36808 11.4176C8.32554 9.54391 9.80844 7.98976 11.6821 7.94438Z",
			fill: "#FEFEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6852 9.6524C12.6193 9.60725 13.4136 10.3275 13.4596 11.2617C13.5055 12.1959 12.7861 12.9908 11.8518 13.0376C10.9165 13.0846 10.1204 12.3639 10.0744 11.4285C10.0283 10.4931 10.7497 9.69762 11.6852 9.6524Z",
			fill: "#34AEE6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.60352 15.9062L8.34485 15.9053C8.32718 16.6684 8.3427 17.4939 8.34257 18.262L17.3977 18.2615C17.3841 18.8241 17.3959 19.4331 17.3957 19.9995L6.6037 20L6.60352 15.9062Z",
			fill: "#FEFEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.067 4.00107L12.8083 4C12.7932 4.595 12.8062 5.26071 12.8061 5.86079L17.0247 5.86011C17.0146 6.42635 17.0282 7.02798 17.0312 7.59768C15.681 7.61188 14.3042 7.59866 12.952 7.59878L6.97473 7.59884L6.97461 5.86126L11.0675 5.8596L11.067 4.00107Z",
			fill: "#FEFEFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.744 15.1369C12.4222 15.0819 13.0162 15.5875 13.07 16.2657C13.124 16.9439 12.6172 17.5372 11.9389 17.5897C11.2623 17.6423 10.6709 17.1371 10.6172 16.4606C10.5635 15.7841 11.0677 15.1918 11.744 15.1369Z",
			fill: "#FEFEFE"
		})
	] })
});
export default SvgIconHwp;
